import { render } from "./profile.html?vue&type=template&id=600319ba&ts=true"
import script from "./profile.ts?vue&type=script&lang=ts"
export * from "./profile.ts?vue&type=script&lang=ts"

import "./profile.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__